/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {ICON_DIRECTIVES} from './index';
export class ClrIconModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [ICON_DIRECTIVES], exports: [ICON_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrIconModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrIconModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrIconModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
